export const RATE_LIMIT_WAIT_TIME_MINUTES = 3;
export const CLEANUP_DELAY_MS = 300;
export const RECAPTCHA_TIMEOUT_MS = 120000; 
export const STATUS_CHECK_INTERVAL_MS = 500;

export const FIREBASE_STORAGE_KEYS = {
  RETRY_AFTER: 'firebase_retry_after',
};

export const ERROR_TYPES = {
  RATE_LIMITED: 'Rate limited',
  USER_CANCELLED: 'User cancelled',
  RECAPTCHA_ERROR: 'reCAPTCHA error',
  INVALID_PHONE: 'Invalid phone number',
  MISSING_PHONE: 'Missing phone number',
};

export const ERROR_CODE_HANDLERS = {
  'auth/too-many-requests': {
    type: ERROR_TYPES.RATE_LIMITED,
    createMessage: (waitMinutes) => `Trop de tentatives. Veuillez attendre ${waitMinutes} minutes avant de réessayer.`,
    needsWaitTime: true
  },
  'auth/invalid-phone-number': {
    type: ERROR_TYPES.INVALID_PHONE,
    message: 'Numéro de téléphone invalide.'
  },
  'auth/missing-phone-number': {
    type: ERROR_TYPES.MISSING_PHONE,
    message: 'Veuillez saisir un numéro de téléphone.'
  },
  'auth/cancelled-popup-request': {
    type: ERROR_TYPES.USER_CANCELLED,
    silent: true
  },
  'auth/popup-closed-by-user': {
    type: ERROR_TYPES.USER_CANCELLED,
    silent: true
  }
};

export const ERROR_MESSAGE_PATTERNS = [
  {
    patterns: ['already been rendered'],
    type: ERROR_TYPES.RECAPTCHA_ERROR,
    message: 'Erreur de configuration reCAPTCHA. Veuillez rafraîchir la page.'
  },
  {
    patterns: ['cancelled'],
    type: ERROR_TYPES.USER_CANCELLED,
    silent: true
  },
  {
    patterns: ['Timeout', 'timeout'],
    type: 'reCAPTCHA timeout',
    message: 'Le délai d\'attente pour le reCAPTCHA a été dépassé. Veuillez réessayer.'
  },
  {
    patterns: ['User cancelled'],
    type: ERROR_TYPES.USER_CANCELLED,
    silent: true
  }
];

export const RECAPTCHA_STATE_ACTIONS = {
  RESOLVED: 'resolved',
  CANCELLED: 'cancelled',
  REPLACED: 'replaced',
  TIMEOUT: 'timeout',
  CLOSED_EXTERNALLY: 'closed_externally'
};
